import { render, staticRenderFns } from "./mealGoodsSku.vue?vue&type=template&id=e16b7764"
import script from "./mealGoodsSku.vue?vue&type=script&lang=ts"
export * from "./mealGoodsSku.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports